import { useTranslations } from '@chilipiper/locale'

export interface Params {
  hideAssignee?: boolean
  isMeetingApprovalFlow?: boolean
  isQueue?: boolean
  isReschedule?: boolean
}

export const usePickTitleText = ({
  isMeetingApprovalFlow,
  isQueue,
  hideAssignee,
  isReschedule,
}: Params) => {
  const [
    pickTimeWithText,
    pickNewTimeWith,
    pickTimeText,
    pickNewTime,
    pickTimeRequestText,
    pickNewTimeRequestText,
  ] = useTranslations([
    'pickTimeWithText',
    'pickNewTimeWith',
    'pickTimeText',
    'pickNewTime',
    'pickTimeRequestText',
    'pickNewTimeRequestText',
  ])

  if (isMeetingApprovalFlow) {
    return isReschedule ? pickNewTimeRequestText : pickTimeRequestText
  }

  if (isQueue && hideAssignee) {
    return isReschedule ? pickNewTime : pickTimeText
  }

  return isReschedule ? pickNewTimeWith : pickTimeWithText
}
